import { fork, call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get links list
 * */
export function* getLinksList() {
    const response = yield call(api.getAnalyticsLinksList);

    if (!response.errors.length) {
        yield put({
            type: actionTypes.GET_ANALYTICS_LINKS_LIST.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_ANALYTICS_LINKS_LIST.FAILURE,
        errors: response.errors,
    });

    return response;
}

export function* watchGetLinksList() {
    while (true) {
        yield take(actionTypes.GET_ANALYTICS_LINKS_LIST.REQUEST);
        yield fork(getLinksList);
    }
}

export default [
    watchGetLinksList,
];




// WEBPACK FOOTER //
// ./app/sagas/analytics/linksList.js